export const serverURL = 'https://api.hees.academy/api/v1'